import { Component, Host, Listen, Prop, h } from '@stencil/core';
import { getDateMMYY } from '../../helpers/date-formatter';

@Component({
  tag: 'pc-vcard-checkout',
  styleUrl: 'pc-vcard-checkout.css',
  shadow: true,
})
export class PcVcardCheckout {
  @Prop() card: {
    number: string;
    expDate: string;
    cvv: string;
    name: string;
  };
  @Prop() merchantDisplayName: string;
  @Prop() configUIData: Record<string, unknown> & CustomUIConfig;

  copyToClipboard(text: string) {
    navigator.clipboard.writeText(text);
  }

  @Listen('copyExpDate')
  expDateCopyClick(event: CustomEvent) {
    this.copyToClipboard(getDateMMYY(event.detail));
  }

  @Listen('copyCVV')
  cvvCopyClick(event: CustomEvent) {
    this.copyToClipboard(event.detail);
  }

  @Listen('copyNumber')
  numberCopyClick(event: CustomEvent) {
    this.copyToClipboard(event.detail);
  }

  renderBullets = (bullets: string[]) => {
    return bullets.map((item: string) => {
      return (
        <li>
          <pc-body-medium>{item}</pc-body-medium>
        </li>
      );
    });
  };

  render() {
    const defaultBullets = [
      `Use the virtual card provided by Progressive to pay ${this.merchantDisplayName} for your device, just like paying with a credit card.`,
      'For billing address use the home address you applied with.',
      `Submit your order with  ${this.merchantDisplayName}.`,
    ];
    const bullets =
      Array.isArray(this.configUIData?.['virtual-card-checkout']?.uibulletstext) && this.configUIData['virtual-card-checkout'].uibulletstext.length > 0
        ? this.configUIData['virtual-card-checkout'].uibulletstext
        : defaultBullets;

    return (
      <Host>
        <div>
          <pc-headline-medium>Pay using the Limited Use Virtual Card</pc-headline-medium>
          <pc-unordered-list>{this.renderBullets(bullets)}</pc-unordered-list>
          <div class="card-wrapper">
            <pc-card class="vcard" canCopy={true} isCommercial={true} number={this.card.number} expDate={this.card.expDate} cvv={this.card.cvv} name={this.card.name} />
            <pc-card-disclosure class="disclosure" />
          </div>
        </div>
      </Host>
    );
  }
}
